module.exports = __webpack_public_path__ + "img/image-21.e53bc968.jpg";